import { Moment } from 'moment'
import { useState, useCallback } from 'react'

interface UseDateSelectionReturn {
	selectedDate: Moment | null
	selectDate: (date: Moment) => void
	clearDate: () => void
}

/**
 * Хук для управления выбором одной даты
 */
export const useDateSelection = (
	initialDate?: Moment | null,
	onChange?: (date: Moment | null) => void,
): UseDateSelectionReturn => {
	const [selectedDate, setSelectedDate] = useState<Moment | null>(
		initialDate || null,
	)

	const selectDate = useCallback(
		(date: Moment) => {
			setSelectedDate(date)
			onChange?.(date)
		},
		[onChange],
	)

	const clearDate = useCallback(() => {
		setSelectedDate(null)
		onChange?.(null)
	}, [onChange])

	return {
		selectedDate,
		selectDate,
		clearDate,
	}
}
